export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=405a47a4dc43657ece9147331dc3fd788304114faa&name=getProductServerAction!'